<template>
<div class="section">
    <div class="container">
        <div class="columns">
            <div class="column">
                <div>
                    <img :src="require('@/assets/images/parcelboy_log@1.png')" alt="parcelboy logo">
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {

}
</script>

<style>

</style>